import { render, staticRenderFns } from "./MondaiPdfUpload.vue?vue&type=template&id=00aa3a03&"
import script from "./MondaiPdfUpload.vue?vue&type=script&lang=ts&"
export * from "./MondaiPdfUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports